import {
    AggregateFunctions,
    AggregateQueryInterval,
    ApiQueryExample,
} from "~/modules/filters/types";
import { AssetTimeseriesGroupBy } from "../../types";

// // // //

const usdcNetAssetValue: ApiQueryExample = {
    key: "usdc_net_asset_value",
    content: {
        label: "USDC Net Asset Value",
    },
    query: {
        aggregate: {
            groupBy: AssetTimeseriesGroupBy.asset,
            aggregateFunction: AggregateFunctions.Sum,
            interval: AggregateQueryInterval.day,
        },
        filter: {
            operator: "and",
            filters: [
                {
                    field: "measure_slug",
                    operator: "equals",
                    value: "net_asset_value_dollar",
                },
                {
                    field: "asset_ticker",
                    operator: "equals",
                    value: "USDC",
                },
            ],
        },
        sort: {
            direction: "asc",
            field: "date",
        },
        pagination: {
            page: 1,
            perPage: 25,
        },
    },
};

export const API_QUERY_EXAMPLES: ApiQueryExample[] = [usdcNetAssetValue];
